module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-unknown-738fc09156bd928bf6481d2d34cfe101.svg";